import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import downArrow from "../images/profile-logo.png";
import Tvlogo from "../images/Tv.webp"
import SwitchType from "./SwitchType";

// import script from "./script.js";
import subsc from "../images/subscription.png";
import rent from "../images/rent.png";
import news from "../images/newsMahua.png";
import sports from "../images/game-icons--run.png";
// import logout from "../images/logout-logo.jpg";

import { fetchGetTypes } from "./Api";
import { Contextone } from "./Context";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import Language from "./Language";
import { NewsContent } from "../App.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import globalSetting from "../configuration.js";
import SideNav from "./SideNav";

// import{ useHistory} from 'react-router-dom'

const Navbar = () => {
  const [types, setTypes] = useState([]);
  const [scrolled, setScrolled] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [displayPopUp, setDisplayPopUp] = useState(false);
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const id01Ref = useRef(null);
  const countercontext = useContext(Contextone);
  const isurl = countercontext.isDomain;
  const apiUrl = `https://${isurl}`;
  const uid = Cookies.get("userid");
  const history = useHistory();
  const location = useLocation();
  const host = window.location.host;
  // const logo = globalSetting[0][host]["REACT_APP_LOGO"];
  const dropdownRef = useRef(null);
  const barRef = useRef(null);
  const searchRef = useRef(null);
  const logo = countercontext.isLogo;

  if (!countercontext.isLogged) {
    Cookies.set("loc", history.location.pathname);
  }

  useEffect(() => {
    if (isPopupOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [isPopupOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const fetchData = async () => {
    try {
      const data = await fetchGetTypes(apiUrl);
      setTypes(data.result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [location]);

  const handleNavLinkClick = (path) => {
    if (history.location.pathname === path) {
      // window.location.reload();
      fetchData();
    }
  };

  const closePopUp = () => {
    setIsPopupOpen(false);
    setDisplayPopUp(false);
  };

  const openPopUp = () => {
    setDisplayPopUp(true);
    setIsPopupOpen(true);
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        setDisplayPopUp(false);
        sessionStorage.clear();
        history.push("/");
      })
      .catch((error) => {
        console.error("Login Error:", error);
      });
    countercontext.setIsLogged(false);
    countercontext.setIsLogOutButton(true);
    localStorage.removeItem("userid");
    Cookies.remove("userid");
    localStorage.removeItem("userPhone");
    setDisplayPopUp(false);
    history.push("/");
    closePopUp();
  };

  let navbarClasses = ["Navbar"];
  if (scrolled) {
    navbarClasses.push("scrolled");
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && searchQuery.trim() !== "") {
      history.push(`/Search/${searchQuery}`);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [searchQuery]);

  const handleLogoClick = () => {
    setShowDropdown(!showDropdown);
  };
  const handleSwitchNewsClick = () => {
    // setShowDropdown(!showDropdown);
    history.push("/");
    countercontext.setShowNewsContent(true);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setIsInputVisible(false);
      setSearchQuery("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const Navigate = useHistory();
  function gotoNewpage() {
    // Newpage();
    Navigate.push("/search");
  }

  const toggleSearchInput = () => {
    // setIsInputVisible(!isInputVisible);
    if (!isInputVisible) {
      setIsInputVisible(true);
    }
  };
  const handleSideNav = () => {
    const sidebar = document.querySelector(".side-navbar");
    if (sidebar.style.display === "block") {
      sidebar.style.display = "none";
    } else {
      sidebar.style.display = "block";
    }
  };
        const decodeVal = (str) => {
        return btoa(str);
      }
      
      const createEncodedData = (id, type_id, video_type, upcoming_type) => {
        const str = `${id}-${type_id}-${video_type}-${upcoming_type}`; 
        return decodeVal(str); 
      };

  return (
    <>
      <div className={navbarClasses.join(" ")}>
        <div className="container-fluid3">
          <Link to={"/"}>
            <img src={logo} alt="Logo" className="navbar-logo" />
          </Link>
          <ul className="menu-bar-ul">
            
            <NavLink
              to={"/search"}
              className="menu-bar"
              
              activeClassName="active-link"
            >
              <img
                className="Movieslogo"
                width="50"
                height="50"
                src="https://img.icons8.com/?size=100&id=7695&format=png&color=FFFFFF"
                alt=""
              />
              <ul>
                <li className="Otherlist">Search</li>
              </ul>
            </NavLink>
            <NavLink
              to={"/"}
              className="menu-bar"
              onClick={() => handleNavLinkClick("/")}
              activeClassName="active-link"
            >
              <img
                className="Movieslogo"
                width="50"
                height="50"
                src="https://img.icons8.com/ios-filled/50/FFFFFF/home.png"
                alt=""
              />
              <ul>
                <li className="Otherlist">Home </li>
              </ul>
            </NavLink>
            {isurl === "mahuaplay.ottsnap.in" ? (
              types
                .filter((type) => type.id !== 5)
                .map((type) => (
                  // <li key={type.id}>
                  // <li>
                  <div key={type.id}>
                    <NavLink
                      // key = {type.id}
                      // to = {`/${type.name.replace(/\s+/g,"")}/${createEncodedData(type.id)}`}
                      to={`/${type.name.replace(/\s+/g, "")}/${type.id}`}
                      activeClassName="active-link"
                      className="menu-bar"
                      onClick={() =>
                        handleNavLinkClick(
                          `/${type.name.replace(/\s+/g, "")}/${type.id}`
                        )
                      }
                    >
                      <img
                      className="Movieslogo"
                      width="64"
                      height="64"
                      src={type.icon} alt="music-library"
                    />
                    <ul>
                      <li className="Otherlist"> {type.name} </li>
                    </ul>
                    </NavLink>
                  </div>
                ))
            ) : (
              <>
                {types.map((type) => (
                  <NavLink  
                    to={`/${type.name.replace(/\s+/g, "")}/${type.id}`}
                    activeClassName="active-link"
                    className="menu-bar"
                    onClick={() =>
                      handleNavLinkClick(
                        `/${type.name.replace(/\s+/g, "")}/${type.id}`
                      )
                    }
                  >
                    <img
                      className="Movieslogo"
                      width="64"
                      height="64"
                      src={type.icon} alt="music-library"
                    />
                    <ul>
                      <li className="Otherlist"> {type.name} </li>
                    </ul>
                  </NavLink>
                ))}
              </>
            )}

            <Language />

            <NavLink
              to={"/Subscription"}
              className="menu-bar"
              activeClassName="active-link"
            >
              <img
                className="Movieslogo"
                width="50"
                height="50"
                src={subsc}
                alt=""
              />
              <ul>
                <li className="Otherlist">Subscription</li>
              </ul>
            </NavLink>
            {isurl === "mahuaplay.ottsnap.in" && (
              // <NavLink
              <div
                to={"/"}
                className="menu-bar"
                onClick={handleSwitchNewsClick}
                // activeClassName="active-link"
              >
                <img
                  className="Movieslogo"
                  width="50"
                  height="50"
                  src={news}
                  alt=""
                />
                <SwitchType />
              {/* </NavLink> */}
              </div>
            )}

            
            <>
              {uid ? (
                <>
                  <div className="menu-container">
                      
                    <NavLink
                      to={"/Profile"}
                      className="menu-bar"
                      activeClassName="active-link"
                    >
                      <img
                        className="Movieslogo"
                        width="50"
                        height="50"
                        src={downArrow}
                        alt=""
                      />
                      <ul>
                        <li className="Otherlist">Profile</li>
                      </ul>
                    </NavLink>
                    <NavLink
                      to={"/Rented"}
                      className="menu-bar"
                      activeClassName="active-link"
                    >
                      <img
                        className="Movieslogo"
                        width="50"
                        height="50"
                        // src={rent}
                        src="https://img.icons8.com/?size=100&id=15910&format=png&color=FFFFFF"
                        alt=""
                      />
                      <ul>
                        <li className="Otherlist">Rent</li>
                      </ul>
                    </NavLink>
                    <div
                      // to={"/logout"}
                      className="menu-bar"
                      activeClassName="active-link"
                      onClick={openPopUp}
                    >
                      <img
                        className="Movieslogo"
                        width="50"
                        height="50"
                        // src={logout}
                        src="https://img.icons8.com/?size=100&id=22112&format=png&color=FFFFFF"
                        alt=""
                      />
                      <ul>
                        <li className="Otherlist">Logout</li>
                      </ul>
                    </div>
                    
                  </div>

                </>
              ) : (
                !countercontext.isLogged && (
                  <NavLink
                  to={"/login"}
                  className="menu-bar"
                  activeClassName="active-link"
                  onClick={() => countercontext.setName(true)}                >
                  <img
                    className="Movieslogo"
                    width="50"
                    height="50"
                    src="https://img.icons8.com/external-tal-revivo-bold-tal-revivo/24/FFFFFF/external-login-access-of-user-with-a-right-direction-arrow-classic-bold-tal-revivo.png"
                    
                  />
                  <ul>
                    <li className="Otherlist">Log in</li>
                  </ul>
                </NavLink>
                 
                  // </Link>
                )
              )}
            </>

            
          </ul>
        </div>
        <div className="barIcon">
          <FontAwesomeIcon icon={faBars} style={{ height: "20px" }} className="open" onClick={handleSideNav} ref={barRef}/>
        </div>
        <SideNav />
      </div>

      

      {displayPopUp && (
        <div>
          <div className={`modal ${isPopupOpen ? "show" : ""}`} ref={id01Ref}>
            <div className="container">
              <p>Are you sure you want to Logout?</p>

              <div className="clearfix">
                <button
                  type="button"
                  onClick={closePopUp}
                  className="cancelbtn"
                >
                  No
                </button>
                <button
                  type="button"
                  onClick={handleLogout}
                  className="removebtn"
                >
                  Sure
                </button>
              </div>
            </div>
          </div>
          {isPopupOpen && <div className="backdrop" onClick={closePopUp} />}
        </div>
      )}
    </>
  );
};

export default Navbar;